import { useEffect, useState } from "react";
import { Box, IconButton, Typography, Drawer, Stack, List, Divider, Tooltip } from "@mui/material";
import { useLocation } from "react-router-dom";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ReportIcon from "@mui/icons-material/Report";
import RadarIcon from "@mui/icons-material/Radar";
import API from "../../api/index";
import ImageFromBase64 from "../../components/imageProfile";
import MovingIcon from "@mui/icons-material/Moving";
import PermDataSettingIcon from "@mui/icons-material/PermDataSetting";
import WebStoriesIcon from "@mui/icons-material/WebStories";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import MapIcon from "@mui/icons-material/Map";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { TiresiaBrain } from "../../components/GeneralIcons";
import PublicIcon from "@mui/icons-material/Public";
import CrisisAlertIcon from "@mui/icons-material/CrisisAlert";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import PrecisionManufacturing from "@mui/icons-material/PrecisionManufacturing"
import DatasetIcon from '@mui/icons-material/Dataset';
import MenuIcon from '@mui/icons-material/Menu';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import SecurityIcon from '@mui/icons-material/Security';
import PolicyIcon from '@mui/icons-material/Policy';
import { MoveDown } from "@mui/icons-material";
import Item from "../../components/SidebarItem";
import { palette } from "../../theme";
import SettingsInputCompositeIcon from '@mui/icons-material/SettingsInputComposite';

const Sidebar = ({ isCollapsed, handleChange, otEnabled = true, orionEnabled = true }) => {
  const [drawerWidth, setDrawerWidth] = useState(isCollapsed ? 80 : 240);
  const [image, setImage] = useState();
  const [imageType, setImageType] = useState();
  const [companyName, setCompanyName] = useState();
  const [nome, setNome] = useState();
  const [cognome, setCognome] = useState();
  const location = useLocation();
  const [selected, setSelected] = useState(location.pathname);
  const [licenseExp, setLicenseExp] = useState(false);
  const expiredLicenseStyle = {
    animation: "blink 1s step-start infinite",
    "@keyframes blink": {
      "0%": {
        color: palette.error.main,
      },
      "50%": {
        color: palette.text.primary,
      },
      "100%": {
        color: palette.error.main,
      },
    },
  }
  const pages = [
    { data: { icon: <HomeOutlinedIcon />, title: "Dashboard", to: "/user/home" } },
    { data: { title: "Security Status" } },
    { data: { icon: <MovingIcon />, title: "Highlights", to: "/user/tiresia-engine/highlights" } },
    {
      header: { title: "Security Log", icon: <RadarIcon /> }, data: [
        { icon: <DatasetIcon />, title: "Aggregations", to: "/user/aggregations" },
        { title: "Detection & Response" },
        { icon: <ReportIcon />, title: "Critical", to: "/user/security/critical" },
        { icon: <HighlightOffIcon />, title: "High", to: "/user/security/high" },
        { title: "Detection" },
        { icon: <ReportIcon />, title: "Alert", to: "/user/security/alert" },
        { icon: <HighlightOffIcon />, title: "Movements", to: "/user/security/movements" }
      ]
    },
    {
      header: { title: "Antlia", icon: <SettingsInputCompositeIcon /> }, data: [
        { icon: <SecurityIcon />, title: "Security", to: "/user/security/ot-security", disabled: !otEnabled },
        { icon: <MoveDown />, title: "Monitor", to: "/user/security/ot-monitor", disabled: !otEnabled },
        { icon: <PrecisionManufacturing />, title: "History", to: "/user/security/ot-protocols", disabled: !otEnabled },
        { icon: <DisplaySettingsIcon />, title: "Tags", to: "/user/security/ot-configuration", disabled: !otEnabled },
      ]
    },
    {
      header: { icon: <PublicIcon />, title: "Intelligence" }, data: [
        { icon: <CrisisAlertIcon />, title: "Threat Intelligence", to: "/user/security/threat-intelligence" },
        { icon: <MapIcon />, title: "Map", to: "/user/extra/map" }
      ]
    },
    { data: { icon: <TiresiaBrain size={20} />, title: "Tires-IA Analysis", to: "/user/tiresia-engine/tiresia-analysis" } },

    { data: { title: "Network" } },
    { data: { icon: <AnalyticsIcon />, title: "Overview", to: "/user/network-status/overview" } },
    { data: { icon: <PermDataSettingIcon />, title: "Inventory", to: "/user/network-status/status" } },
    { data: { icon: <PolicyIcon />, title: "Network Zones", to: "/user/network-status/zones", disabled: !orionEnabled, disabledReason: "Orion module is disabled" } },
    { data: { icon: <WebStoriesIcon />, title: "Infrastructure Log", to: "/user/network-status/infrastructure-log" } },
    { data: { title: "Tools" } },
    { data: { icon: <DisplaySettingsIcon />, title: "LECS Management", to: "/user/lecs-management" } },
    { data: { icon: <WarningAmberIcon />, title: "Incident Analysis", to: "/user/tiresia-engine/incident-context" } },
    { data: { title: "Support" } },
    { data: { icon: <LocalActivityIcon />, title: "Ticket", to: "/user/support/ticket" } },
  ];

  useEffect(() => {
    setLicenseExp(Boolean(sessionStorage.getItem("license_expired")));
    if (sessionStorage.getItem("ragioneSociale") && sessionStorage.getItem("nomeUser") && sessionStorage.getItem("cognomeUser")) {
      setImage(sessionStorage.getItem("profileImage"));
      setCompanyName(sessionStorage.getItem("ragioneSociale"));
      setImageType(sessionStorage.getItem("imageType"));
      setNome(sessionStorage.getItem("nomeUser"));
      setCognome(sessionStorage.getItem("cognomeUser"));
    } else {
      API.getDataUsers().then((res) => {
        setImage(res.data.profileImage);
        setCompanyName(res.data.ragioneSociale);
        setImageType(res.data.imageType);
        setNome(res.data.nome);
        setCognome(res.data.cognome);
        sessionStorage.setItem("profileImage", res.data.profileImage);
        sessionStorage.setItem("ragioneSociale", res.data.ragioneSociale);
        sessionStorage.setItem("imageType", res.data.imageType);
        sessionStorage.setItem("nomeUser", res.data.nome);
        sessionStorage.setItem("cognomeUser", res.data.cognome);
      }).catch(() => {
        setImage("");
        setCompanyName("");
        setImageType("");
        setNome("");
        setCognome("");
      });
    }
  }, []);

  useEffect(() => {
    if (isCollapsed) {
      setDrawerWidth(80);
    } else {
      setDrawerWidth(240);
    }
  }, [isCollapsed]);

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        "& .MuiDrawer-paper": { width: drawerWidth }
      }}
    >
      <Stack direction={'column'} spacing={1} alignItems={'center'} justifyContent={'top'} height={'100%'} minWidth={0} width={"100%"}>
        {!isCollapsed ? (
          <>
            <img
              src="/logo-lecs.png"
              alt="LECS"
              style={{ width: "auto", height: "50px", alignSelf: "start" }}
            />

            <Box sx={{ display: "flex", width: "max-content", backgroundColor: 'transparent', borderRadius: "50%" }}>
              <ImageFromBase64 base64Data={image} format={imageType} style={{ width: "100px", height: "100px" }} />
            </Box>

            <Typography variant="h4" fontWeight="bold">
              {companyName}
            </Typography>

            <Typography variant="h6">
              {nome} {cognome}
            </Typography>
          </>
        ) : (
          <Box sx={{ display: "flex", width: "max-content", backgroundColor: 'transparent', borderRadius: "50%", pt: 5 }}>
            <ImageFromBase64 base64Data={image} format={imageType} style={{ width: "50px", height: "50px" }} />
          </Box>
        )}

        <Box height={"100%"} overflow={"auto"} px={2} minWidth={0} width={"100%"}>
          <List>
            {
              pages.filter(page => page != null).map((page, index) => (
                <Item
                  key={index}
                  data={page.data}
                  header={page?.header}
                  isCollapsed={isCollapsed}
                  selected={selected}
                  setSelected={setSelected}
                />
              ))
            }
          </List>
        </Box>

        <Divider flexItem />
        <Stack direction={isCollapsed ? "column" : "row"} spacing={1} p={1.5} width={"100%"} justifyContent={"space-between"} alignItems={"center"}>
          {licenseExp && isCollapsed ?
            <Tooltip title="License Expired">
              <WarningAmberIcon sx={expiredLicenseStyle} />
            </Tooltip>
            :
            licenseExp && !isCollapsed ?
              <Typography sx={expiredLicenseStyle} fontWeight={600} fontSize={17} display={"flex"} alignItems={"center"}>
                <WarningAmberIcon />License Expired
              </Typography>
              :
              !isCollapsed ?
              <Typography fontSize={12} display={"flex"} alignItems={"center"}>
                v8.6
              </Typography>
              :
              <div/>
          }
          <IconButton onClick={() => handleChange()}>
            {isCollapsed ? <MenuIcon /> : <ArrowBackIosNewIcon />}
          </IconButton>
        </Stack>
      </Stack>
    </Drawer>
  )
};

export default Sidebar;